import React, { useEffect } from "react"
import { useSearchParams } from "react-router-dom"
import { addMedicineSku } from "./action"
import { useNavigate } from "react-router-dom"
import css from "./InsightSupplement.scss"

function InsightsSupplement() {
    const navigate = useNavigate()
    const [searchParams] = useSearchParams()

    useEffect(() => {
        const skuIds = searchParams.get("sku_ids")?.split(",")
        const quantities = searchParams.get("quantities")?.split(",")
        const listOfMedicines = []
        for (let i = 0; i < skuIds?.length; i++) {
            const quantity = parseInt(quantities[i])
            listOfMedicines.push({
                quantity: quantity || 1,
                sku_id: skuIds[i],
            })
        }

        addMedicineSku(
            {
                is_recommendation_required: true,
                page_source: "health_rec",
                response_type: "brief",
                skus: listOfMedicines,
                types: "pharmacy",
            },
            navigate
        )
    }, [])

    return (
        <div
            style={{ height: "calc(100vh - 48px)" }}
            className={`flex alignCenter justifyCenter ${css.insight}`}
        >
            <div className="l4SemiBold col-4 textCenter">Adding Supplements to your cart...</div>
        </div>
    )
}

export default InsightsSupplement
